import {PartnerState} from './partnerState';
import {PartnerType} from './partnerType';
import {User} from './user';
import { Document } from '../document';

export interface Partner {
  id: number;
  name: string;
  surName: string;
  avatar: string;
  city?: string;
  color?: string;
  comment?: string;
  countryId?: number;
  currencyId?: number;
  email?: string;
  billingEmail?: string;
  employee?: string;
  position?: string;
  isBlacklisted?: boolean;
  isCompany?: boolean;
  isActive?: boolean;
  mobile?: string;
  parentId?: number;
  latitude?: number;
  longitude?: number;
  phone?: string;
  stateId?: number;
  state?: PartnerState;
  street?: string;
  street2?: string;
  partnerTypeId?: number;
  partnerType?: PartnerType;
  vat?: string;
  website?: string;
  zip?: string;
  imo?: string;
  user?: User;
  documents?: Document[]
  parentPartner?:{name:string,id:number}
  parent?:{name:string,id:number}
}

export interface PartnerCreate {
  "avatar": string,
  "city": string,
  "color": string,
  "comment": string,
  "countryId": number,
  "currencyId": number,
  "email": string,
  "employee": string,
  "position": string,
  "isBlacklisted": boolean,
  "isCompany": boolean,
  "isActive": boolean,
  "mobile": string,
  "name": string,
  "surName": string,
  "parentId": number,
  "latitude": number,
  "longitude": number,
  "phone": string,
  "stateId": number,
  "street": string,
  "street2": string,
  "partnerTypeId": number,
  "vat": string,
  "website": string,
  "zip": string,
  "imo": string
}

/**
 * Cuerpo de un PATCH de Partner: el id mas cualquier subconjunto de campos.
 * Admite null explicito porque esa es justo la semantica del endpoint —
 * enviar un campo a null lo limpia, no enviarlo lo deja como estaba.
 */
export type PatchPartnerPayload = { id: number } & {
  [K in keyof Omit<Partner, 'id'>]?: Partner[K] | null;
};

/** Una asociacion/desasociacion de un empleado: parentId null desasocia. */
export interface SetParentOperation {
  partnerId: number;
  parentId: number | null;
}

/**
 * Resultado de un lote de asociacion. Se reporta por operacion para que la UI
 * pueda decir exactamente que paso: hoy el lote son N llamadas y puede fallar
 * una parte; cuando exista POST /api/partner/set-parent (CEC-598) la respuesta
 * atomica se mapea a esta misma forma.
 */
export interface SetParentResult {
  succeeded: number[];
  failed: Array<{ partnerId: number; reason: string }>;
}
